import * as Scrivito from "scrivito";
import metadataAttributes from "../_metadataAttributes";
import defaultPageAttributes from "../_defaultPageAttributes";

export const degreeValues = [
  "bachelorOfArts",
  "bachelorOfScience",
  "bachelorOfEngineering",
  "masterOfScience",
  "masterOfArts",
  "masterOfEngineering",
  "masterOfBusinessAdm",
];

const CoursePage = Scrivito.provideObjClass("CoursePage", {
  // hide add ne Object buttons inside contentBrowser
  onlyInside: ["CourseOverviewPage"],
  attributes: {
    ...defaultPageAttributes,
    shortTitle: "string",
    courseDescription: "string",
    courseWorkload: "string",
    orientation: [
      "multienum",
      { values: ["technology", "business", "informatics"] },
    ],

    degree: ["enum", { values: degreeValues }],

    semester: ["enum", { values: ["2", "3", "4", "6", "7", "8"] }],
    credits: ["enum", { values: ["45", "180", "90", "120", "210"] }],
    creditsStandard: ["enum", { values: ["ECTS", "US-Credits"] }],
    lang: ["multienum", { values: ["de", "en", "esp"] }],
    courseFilterLang: ["multienum", { values: ["de", "en"] }],
    doesMatchAllLanguages: ["enum", { values: ["yes", "no"] }],
    tuitionFee: "float",
    factsheet: ["reference", { only: ["Download"] }],
    location: [
      "multienum",
      {
        values: ["techcampus", "bildungscampus", "kuenzelsau", "schwaebisch"],
      },
    ],
    customLocation: "stringlist",
    form: [
      "multienum",
      { values: ["full", "coop", "work", "external", "indepth"] },
    ],
    start: ["multienum", { values: ["summer", "winter"] }],
    customStart: "stringlist",
    deadline: ["multienum", { values: ["January 15", "July 15"] }],
    customDeadline: "stringlist",
    hideOnCourseFinderPage: "boolean",
    admissionType: ["enum", { values: ["enroll", "apply"] }],
    ...metadataAttributes,

    additionalLocationInfo: "string",
    additionalCreditsInfo: "string",
    additionalStartInfo: "string",
    additionalDeadlineInfo: "string",
    additionalLangInfo: "string",
    additionalDegreeInfo: "string",
    additionalFormInfo: "string",
    additionalCourseWorkloadInfo: "string",
    additionalTuitionFeeInfo: "string",
    additionalOrientationInfo: "string",
  },
  extractTextAttributes: ["body", "title", "segmentName", "shortTitle"],
});

export default CoursePage;
